<template>
  <section class="team-section">
    <div class="team-header">
      <div class="team-intro">
        <h2 class="title">{{ text.team.title }}</h2>
        <divider-line />
        <p class="description">{{ text.team.description }}</p>
      </div>
    </div>
    
    <div class="team-grid">
      <div v-for="(member, index) in text.team.members" :key="index" class="team-member" @click="!member.image.includes('new_hire') && openModal(index)">
        <div class="member-image">
          <img :src="`${publicPath}${member.image}`" :alt="member.name">
        </div>
        <div class="member-info">
          <h3 class="member-name">{{ member.name }}</h3>
          <p class="member-role">{{ member.role }}</p>
          <p class="member-preview">{{ getPreview(member.description) }} <span v-if="!member.image.includes('new_hire')" class="see-more-text">En savoir plus</span></p>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal-fade">
      <div v-if="selectedMember !== null" class="modal-backdrop" @click="closeModal">
        <div class="modal-content" @click.stop>
          <button class="modal-close" @click="closeModal">&times;</button>
          <div class="modal-body">
            <div class="modal-image">
              <img :src="`${publicPath}${text.team.members[selectedMember].image}`" :alt="text.team.members[selectedMember].name">
            </div>
            <div class="modal-info">
              <h3 class="modal-name">{{ text.team.members[selectedMember].name }}</h3>
              <p class="modal-role">{{ text.team.members[selectedMember].role }}</p>
              <div class="modal-description" v-html="text.team.members[selectedMember].description"></div>
              <img v-if="text.team.members[selectedMember].endorsement" :src="`${publicPath}${text.team.members[selectedMember].endorsement}`" :alt="`${text.team.members[selectedMember].name} endorsement`" class="modal-endorsement">
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import json from '../../text.json'
import DividerLine from '@/components/dividerLine.vue'

export default {
  name: "teamSection",
  components: { DividerLine },
  data() {
    return {
      text: json,
      publicPath: '/',
      selectedMember: null,
      scrollPosition: 0
    }
  },
  methods: {
    getPreview(description) {
      const text = description.replace(/<[^>]*>/g, '');
      return text.length > 90 ? text.substring(0, 90) + '...' : text;
    },
    openModal(index) {
      this.scrollPosition = window.pageYOffset;
      this.selectedMember = index;
      document.body.style.overflow = 'hidden';

    },
    closeModal() {
      this.selectedMember = null;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
    }
  },
  beforeUnmount() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }
}
</script>

<style scoped>
</style>
